// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3_kY9","header":"PatientBlock_header__2pYZB","label":"PatientBlock_label__BSM2K","option":"PatientBlock_option__3GcC4"};